var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import './../../scss/paywall/index.scss';
import * as React from "react";
import { render } from 'react-dom';
import { fetchApi, getLang } from './helpers';
import { HttpMethods } from 'tagwalk-api-client/assets/js/common/enums';
import { initAnalytics } from "../paywall_tts";
import { checkFingerprint } from "./paywallFingerprint";
import { PaywallBlockMultipleUsers } from "./modals/PaywallBlockMultipleUsers";
import { SubscriptionsStoreInstance } from "@ts/common/service-instance/SubscriptionsStoreInstance";
import { getSegment } from "./paywallSegment";
var WIDGET_TARGET = '#pw-widget';
var BLOCK_MULTIPLE_USERS_ROOT_ID = 'pw-block-multiple-users';
var debug = false;
var Paywall = (function () {
    function Paywall(configuration, subscription) {
        var _this = this;
        this.render = function (configuration, subscription, widget, segment) { return __awaiter(_this, void 0, void 0, function () {
            var response, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        debug && logDebug('Fetching Paywall template.');
                        return [4, fetchApi('api_paywall_render', HttpMethods.get, {
                                locale: getLang(),
                                context: configuration.context,
                                segment: segment
                            })];
                    case 1:
                        response = _a.sent();
                        return [4, response.json()];
                    case 2:
                        data = _a.sent();
                        widget.innerHTML = data.content;
                        if (!!configuration.onLock) {
                            debug && logDebug('Configuring lock listener');
                            configuration.onLock();
                        }
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        debug && logDebug('Error rendering paywall:', error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        this.configuration = configuration;
        this.widget = document.querySelector(WIDGET_TARGET);
        if (!this.widget) {
            throw new Error('Widget target not found');
        }
        debug && logDebug('Resolving segment');
        var segment = !!configuration.overrideSegment
            ? configuration.overrideSegment(subscription, getSegment)
            : getSegment(subscription);
        debug && logDebug("Resolved custom segment: %c'" + segment + "'", 'font-style: italic; color: #DC3635');
        this.render(this.configuration, subscription, this.widget, segment).then(function () {
            debug && logDebug('Paywall displayed. Initializing analytics.');
            initAnalytics(_this.configuration.context, segment);
        });
    }
    Paywall.prototype.hide = function () {
        var _a, _b;
        if (((_a = this.widget) === null || _a === void 0 ? void 0 : _a.classList.contains('d-none')) === true) {
            return;
        }
        (_b = this.widget) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        debug && logDebug('Paywall hidden');
    };
    Paywall.prototype.show = function () {
        var _a;
        (_a = this.widget) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        debug && logDebug('Previously hidden paywall shown again');
    };
    Paywall.prototype.isOpen = function () {
        var _a;
        return !((_a = this.widget) === null || _a === void 0 ? void 0 : _a.classList.contains('d-none'));
    };
    return Paywall;
}());
var createPaywall = function (configuration) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, userInLocalStorage, user, subscription, result, isSameDevice, body, root;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchParams = new URLSearchParams(window.location.search);
                debug = searchParams.has('debug') ? !!searchParams.get('debug') : false;
                userInLocalStorage = localStorage.getItem('user');
                user = !!userInLocalStorage ? JSON.parse(userInLocalStorage) : null;
                if ((user === null || user === void 0 ? void 0 : user.email.includes('@asos.com')) === true) {
                    debug && logDebug('User has a valid subscription from a company deal, aborting');
                    return [2, null];
                }
                return [4, getSubscription()];
            case 1:
                subscription = _a.sent();
                if (!subscription) {
                    if (localStorage.getItem('has_subscription')) {
                        localStorage.removeItem('has_subscription');
                    }
                    return [2, null];
                }
                if (!(configuration.authorizedPlans && hasValidSubscription(configuration.authorizedPlans, subscription) === true)) return [3, 3];
                localStorage.setItem('has_subscription', 'true');
                return [4, checkFingerprint()];
            case 2:
                result = _a.sent();
                if (!result) {
                    return [2, null];
                }
                isSameDevice = result.isSameDevice;
                if (isSameDevice) {
                    return [2, null];
                }
                if (subscription.quantity !== undefined && subscription.quantity > 1) {
                    return [2, null];
                }
                body = document.querySelector('body');
                if (!body) {
                    return [2, null];
                }
                root = document.getElementById(BLOCK_MULTIPLE_USERS_ROOT_ID);
                if (!root) {
                    root = document.createElement('div');
                    root.id = BLOCK_MULTIPLE_USERS_ROOT_ID;
                    body.insertBefore(root, body.lastChild);
                }
                render(React.createElement(PaywallBlockMultipleUsers, { subscription: subscription }), root);
                return [2, null];
            case 3:
                localStorage.setItem('has_subscription', 'false');
                if (abort(configuration, subscription) === true) {
                    return [2, null];
                }
                debug && logDebug('The paywall will now be initialized with the following configuration', configuration);
                return [2, new Paywall(configuration, subscription)];
        }
    });
}); };
var hasValidSubscription = function (authorizedPlans, subscription) {
    if (!subscription.plan) {
        return false;
    }
    var valid = authorizedPlans.includes(subscription.plan)
        && subscription.status === 'active'
        && new Date(subscription.ends_at) >= new Date();
    if (valid && debug) {
        logDebug('User has a valid and active subscription, aborting');
    }
    return valid;
};
var abort = function (configuration, subscription) {
    if (typeof configuration.shouldAbort !== 'function') {
        return false;
    }
    var data = configuration.shouldAbort(subscription);
    if (data.result === false) {
        return false;
    }
    debug && logDebug('Paywall not displayed' + (data.reason ? ', reason: ' + data.reason : ''));
    return true;
};
var getSubscription = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, SubscriptionsStoreInstance.getPaywallSubscription()];
            case 1: return [2, _a.sent()];
        }
    });
}); };
var logDebug = function (message, context) {
    var data = [
        "%cPaywall%c " + message,
        'color: white; background-color: #8533ff; padding: 2px 5px; border-radius: 2px',
        'color: auto; background-color: none; padding: none; border-radius: none'
    ];
    if (context) {
        data.push(context);
    }
    console.log.apply(console, data);
};
export { createPaywall };
